export default __webpack_public_path__ + "static/media/safari-audio-config.4e939b15.gif";